var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BrandHeader'),_c('router-view'),_c('BrandFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }